import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { MonTranslationService } from '@monsido/core/translation/translation.service';
import { TranslateModule } from '@client/app/modules/translate.module';

function init_app (appLoadService: MonTranslationService) {
    return (): Promise<unknown> => appLoadService.initializeApp();
}

@NgModule({
    imports: [TranslateModule],
    exports: [TranslateModule],
    declarations: [],
    providers: [
        MonTranslationService,
        provideAppInitializer(() => {
            const initializerFn = (init_app)(inject(MonTranslationService));
            return initializerFn();
        }),
    ],
})
export class MonTranslationModule {}
